import { useRef, useEffect } from "react"
import { useLightswarm } from "@src/providers/lightswarm/LightswarmProvider"

const useLightControl = (selectedRows: any[], unitsToLight: any[]) => {
  const prevUnitsToLightRef = useRef<any[]>([])
  const { turnLightsOn, turnLightsOff } = useLightswarm()

  useEffect(() => {
    let units = []

    // If there are selected rows, light them up
    if (selectedRows && selectedRows.length > 0) {
      units = selectedRows
        .filter((unit) => unit !== null)
        .map((unit) => ({
          Name: unit.unitName?.slice(1),
        }))
    }

    // If no selected rows or all selected rows are null, fallback to unitsToLight
    if (units.length === 0) {
      units = unitsToLight
    }

    const unitsChanged = !arraysAreEqual(units, prevUnitsToLightRef.current)

    if (unitsChanged) {
      turnLightsOn(units)
      prevUnitsToLightRef.current = units
    }
  }, [selectedRows, unitsToLight, turnLightsOn])

  const arraysAreEqual = (arr1: any[], arr2: any[]) => {
    if (arr1.length !== arr2.length) return false
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i].Name !== arr2[i].Name) return false
    }
    return true
  }
}

export default useLightControl
